// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/core/api/v2/activity.proto" (package "bianka.core.api.v2", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { TrafficSource } from "../../../common/v1/traffic_source";
import { HttpRequest } from "../../../common/v1/http_request";
import { Locale } from "../../../common/activity/v1/locale";
import { User } from "../../enrichment/user";
import { Page } from "../../../common/activity/v1/page";
import { Platform } from "../../enums/platform";
import { Metadata } from "../../../common/v1/metadata";
/**
 * Next serial number to be used: 10
 *
 * @generated from protobuf message bianka.core.api.v2.ActivityEvent
 */
export interface ActivityEvent {
    /**
     * Metadata about the event
     *
     * @generated from protobuf field: bianka.common.v1.Metadata metadata = 1;
     */
    metadata?: Metadata;
    /**
     * Device's uid
     *
     * @generated from protobuf field: string uid = 2;
     */
    uid: string;
    /**
     * The platform the event was produced from. Can be either web, mobile web or mobile app
     *
     * @generated from protobuf field: bianka.core.enums.Platform platform = 3;
     */
    platform: Platform;
    /**
     * Data regarding the page the activity comes from
     *
     * @generated from protobuf field: bianka.common.activity.v1.Page page = 4;
     */
    page?: Page;
    /**
     * Data regarding the user that performed the action
     *
     * @generated from protobuf field: bianka.core.enrichment.User user = 5;
     */
    user?: User;
    /**
     * Data regarding current session locale
     *
     * @generated from protobuf field: bianka.common.activity.v1.Locale locale = 6;
     */
    locale?: Locale;
    /**
     * Data regarding the http request
     *
     * @generated from protobuf field: bianka.common.v1.HttpRequest http_request = 8;
     */
    httpRequest?: HttpRequest;
    /**
     * Data regarding the traffic source
     *
     * @generated from protobuf field: bianka.common.v1.TrafficSource traffic_source = 9;
     */
    trafficSource?: TrafficSource;
    /**
     * Data regarding the specific event
     *
     * @generated from protobuf field: google.protobuf.Any event = 7;
     */
    event?: Any;
    /**
     * Extended Data regarding the specific event
     *
     * @generated from protobuf field: google.protobuf.Any additional_data = 10;
     */
    additionalData?: Any;
}
// @generated message type with reflection information, may provide speed optimized methods
class ActivityEvent$Type extends MessageType<ActivityEvent> {
    constructor() {
        super("bianka.core.api.v2.ActivityEvent", [
            { no: 1, name: "metadata", kind: "message", T: () => Metadata },
            { no: 2, name: "uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "platform", kind: "enum", T: () => ["bianka.core.enums.Platform", Platform, "PLATFORM_"] },
            { no: 4, name: "page", kind: "message", T: () => Page },
            { no: 5, name: "user", kind: "message", T: () => User },
            { no: 6, name: "locale", kind: "message", T: () => Locale },
            { no: 8, name: "http_request", kind: "message", T: () => HttpRequest },
            { no: 9, name: "traffic_source", kind: "message", T: () => TrafficSource },
            { no: 7, name: "event", kind: "message", T: () => Any },
            { no: 10, name: "additional_data", kind: "message", T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.core.api.v2.ActivityEvent
 */
export const ActivityEvent = new ActivityEvent$Type();
